import { t } from "@/i18n-js/instance";
import { Filter } from "@circle-react-shared/FilterV3";
import { RadioFilter } from "@circle-react-shared/FilterV3/RadioFilter";

interface TypeFilterProps {
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  value: string;
}

export const TypeFilter = ({ value, onChange, options }: TypeFilterProps) => {
  const selectedOptionLabel =
    options.find(opt => opt.value === value)?.label || "";

  return (
    <Filter
      onApply={val => {
        if (val === null) {
          onChange("");
        } else if (
          val &&
          typeof val === "object" &&
          "value" in val &&
          typeof val.value === "string"
        ) {
          onChange(val.value);
        }
      }}
    >
      <Filter.Chip renderSelectedValue={() => selectedOptionLabel}>
        {t("settings.community_bot.knowledge.filters.type_chip")}
      </Filter.Chip>
      <Filter.Popover
        title={t("settings.community_bot.knowledge.filters.type_title")}
        isInitialOpen={false}
        shouldShowRemoveButton
      >
        <RadioFilter
          options={options}
          legend={t("settings.community_bot.knowledge.filters.type_legend")}
          value={value}
        />
      </Filter.Popover>
    </Filter>
  );
};
